import TimeOffBalanceSlider from './TimeOffBalanceSlider.component';

export default TimeOffBalanceSlider;
